// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/4037
import type { PAPEventGeneric } from "../base/event";
import type { DashActionSurface } from "../enums/dash_action_surface";

// Event_name: 'open.result_preview_modal'
// Description: Open result preview modal
// Owner: dash-exp-find-and-discover
export type Open_ResultPreviewModal = PAPEventGeneric<
  'previews',
  'open',
  'result_preview_modal',
  {
    // Legacy: dash_connector_id in Desktop
    // Note, this should have been a enum :(
    connector?: string;
    // Unique identifier (UUIDv5 ) of the search result
    resultUuid?: string;
    // id that groups all queries in a single "session" for logging
    searchSessionId?: string;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Unique identifier for a viewing session of a preview
    previewModalUuid?: string;
  }
>;

export function PAP_Open_ResultPreviewModal(properties?: Open_ResultPreviewModal['properties']): Open_ResultPreviewModal {
  return <Open_ResultPreviewModal>{
    class: 'previews',
    action: 'open',
    object: 'result_preview_modal',
    properties,
  };
}
